var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Color } from '../const';
var TextFieldEditable = function (props) {
    var width = props.width;
    return React.createElement(Wrapper, { width: width }, props.children);
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 4px;\n  box-shadow: 0 0 10px ", ";\n  padding: 8px;\n  width: ", "px;\n"], ["\n  background-color: ", ";\n  border-radius: 4px;\n  box-shadow: 0 0 10px ", ";\n  padding: 8px;\n  width: ", "px;\n"])), Color.BACKGROUND_COLOR, Color.DARK_GRAY_2, function (_a) {
    var width = _a.width;
    return width || 175;
});
export default TextFieldEditable;
var templateObject_1;
//# sourceMappingURL=text-field-editable.js.map